import type { RenovationType } from '@entities/hotel';

function filterHotelByRenovation(hotel: { renovationTypes: RenovationType[] }, renovations: RenovationType[]): boolean {
    if (renovations.length === 0) return true;
    if (!hotel.renovationTypes?.length) return false;

    return hotel.renovationTypes.some((type) => renovations.includes(type));
}

export default filterHotelByRenovation;
